export default [
    {
        key: "forwardhead",
        name: "Proéminence de la tête",
        definition: {
            name: "Définition",
            list: ["La proéminence de la tête signifie que lorsque le corps humain est dans une position naturelle debout ou assis, la tête est dans une position anormalement inclinée vers l'avant par rapport au tronc. C'est courant chez les étudiants et les personnes de bureau qui restent assises longtemps."]
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1、Travail penché pendant longtemps. Lorsqu'on travaille longtemps devant l'ordinateur, la tête s'incline habituellement vers l'avant.",
                "2. Avoir l'habitude de baisser la tête pour regarder son téléphone portable. Regarder son téléphone portable avec la tête baissée, c'est-à-dire la fameuse ‘tribu des tête baissée’, est également une des principales causes d'induction de la proéminence de la tête.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Vertiges et maux de tête: La proéminence de la tête peut affecter la circulation sanguine dans la tête. En raison d'un mauvais flux sanguin, il y a un manque d'oxygène dans la tête, ce qui provoque des vertiges et des maux de tête.",
                "2. Cervicalgies: En raison de la position anormale de la tête, des anomalies apparaissent dans les tissus mous et les os du cou, augmentant le risque de maladies cervicales.",
                "3. Maladies cardiovasculaires et cérébrovasculaires: La position anormale de la tête peut affecter la circulation sanguine dans la tête et nuire à la santé cardiovasculaire et cérébrovasculaire.",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "Inclinaison latérale de la tête",
        definition: {
            name: "Définition",
            list: ["Inclinaison latérale de la tête se réfère à la posture anormale où la tête est excessivement inclinée vers un c?té lorsque le corps humain est dans une position naturelle debout ou assis. La principale cause est le déséquilibre de la force musculaire du cou et des épaules des deux c?tés, généralement causé par des postures incorrectes habituelles."]
        },
        triggerreason: {
            name: "Causes",
            list: [
                "1. Utiliser habituellement les muscles du cou et de l'épaule d'un c?té: Lorsqu'on est assis ou couché, le cou s'incline souvent seulement d'un c?té, ce qui provoque un déséquilibre de la force musculaire du cou et des épaules des deux c?tés.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Lésions chroniques des muscles et des ligaments: L'inclinaison latérale de la tête pendant une longue période peut facilement entra?ner une lésion chronique des ligaments postérieurs du cou et des ligaments et des muscles.",
                "2. Cervicalgies: En raison de la position anormale de la tête, des anomalies apparaissent dans les tissus mous et les os du cou, augmentant le risque de maladies cervicales.",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "épaules inégales",
        definition: {
            name: "Définition",
            list: ["épaules inégales se réfère à la situation où les épaules des deux c?tés ont des hauteurs verticales différentes lorsque le corps humain est dans un état de relaxation naturelle. Généralement, les épaules inégales s'accompagnent d'anomalies dans la posture de la colonne vertébrale."]
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1. Force excessive sur un c?té: par exemple, porter un sac à dos ou des objets lourds sur un c?té pendant une longue période.",
                "2. Mauvaise posture pendant longtemps: Causée par de mauvaises habitudes comme croiser les jambes et rester assis longtemps, ou s'incliner sur la table en travaillant penché.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Douleur au dos: (épaules inégales) peuvent provoquer un déplacement du bassin, entra?nant un déséquilibre de la force musculaire des deux c?tés de la taille et causant des douleurs au dos.",
                "2. Ostéophyte: Les épaules inégales entra?nent une force anormale sur la colonne cervicale et peuvent finalement entra?ner une dégénération de la région de la colonne cervicale et faciliter la formation d'ostéophytes.",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "épaules rondes",
        definition: {
            name: "Définition",
            list: ["Les épaules rondes désignent l’état dans lequel les épaules semblent se courber vers l’avant et vers l’intérieur lorsqu’on les observe latéralement. Souvent accompagné de cyphose. Courant chez les élèves et les personnes travaillant dans les bureaux."],
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1. Mauvaise posture habituelle: comme se pencher et avoir une bosse, s'allonger sur le c?té de manière irrégulière etc.",
                "2. Déséquilibre musculaire entre le thorax et le dos: Les muscles pectoraux sont relativement faibles par rapport aux muscles du dos.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Augmentation de la charge sur le c?ur: Des épaules trop rondes feront que le diaphragme soit tendu, causant une compression de l'aorte et de la veine cave et augmentant la charge de travail du c?ur.",
                "2. Compression des nerfs: La tension musculaire autour des épaules et du cou peut, dans les cas graves, comprimer les nerfs cervicaux et provoquer des maux de tête et un engourdissement du bras.",
            ],
        }
    },
    {
        name: "scoliose",
        key: "scoliosis",
        definition: {
            name: "Définition",
            list: ["Il y a des anomalies dans la position de la colonne vertébrale. Par des examens d'imagerie, on peut détecter des états non droits de la colonne vertébrale, comme la scoliose. Les anomalies peuvent être divisées en congénitales et acquises. Les anomalies acquises sont liées aux erreurs habituelles de posture."],
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1. Force unilatérale excessive: par exemple, porter un sac à dos ou soulever des objets lourds d'un c?té pendant longtemps.",
                "2. Mauvaise posture pendant longtemps: Causée par de mauvaises habitudes comme croiser les jambes et rester assis longtemps, ou s'incliner sur la table en travaillant penché.",
                "3. Causes congénitales: Scoliose causée par des facteurs congénitaux.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Hernie discale lombaire.",
                "2. Douleur lombaire: Peut provoquer un déplacement du bassin, rendant la force musculaire des deux c?tés de la taille déséquilibrée et entra?nant des douleurs lombaires.",
                "3. Jambes de longueurs différentes.",
            ],
        }
    },
    {
        name: "inclinaison latérale du bassin",
        key: "unevenhip",
        definition: {
            name: "Définition",
            list: ["L’inclinaison latérale du bassin désigne l’état où la hauteur des hanches des deux c?tés est assez différente, présentant un état d’inclinaison du bassin. Souvent accompagné d’anomalies de la position de la colonne vertébrale et d’épaules inégales."],
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1. Mauvaise posture pendant longtemps: Causée par de mauvaises habitudes comme croiser les jambes et rester assis longtemps, ou s'incliner sur la table en travaillant penché.",
                "2. Jambes de longueurs différentes congénitales: Inclinaison latérale du bassin due à des jambes de longueurs différentes congénitales.",
                "3. Déséquilibre postural des membres inférieurs des deux c?tés: par exemple, un pied a un pied plat tandis que l’autre n’en a pas, ou le degré est différent; les deux c?tés ont une hyper-extension du genou, mais le degré est différent.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Hernie discale lombaire.",
                "2. Douleur chronique: L’inclinaison latérale du bassin peut entra?ner des douleurs aux jambes, à la taille, ainsi qu’au cou et aux épaules.",
                "3. Jambes de longueurs différentes.",
            ],
        }
    },
    {
        name: "genoux en forme de O",
        key: "oleg",
        definition: {
            name: "Définition",
            list: ["Quand une personne est debout avec une posture normale et les pieds sont joints, les chevilles internes peuvent être collées mais les intérieurs des genoux ne peuvent pas être collés et il peut même y avoir un grand espace. Entre les jambes appara?t une forme en ? O ?. Ce type de forme de jambe est lié aux habitudes de posture quotidienne. L’apparition de jambes en forme de ? O ? chez les enfants peut également être liée au rachitisme."],
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1. Mauvaises habitudes posturales comme : inclinaison postérieure du bassin et tendance à la pronation du pied.",
                "2. Déséquilibre de force musculaire, comme : muscles rotateurs externes de la hanche trop serrés.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Blessure du ménisque médial: Les jambes en forme de O entra?nent des changements dans la ligne de force des membres inférieurs. L'espace médial du genou subit une pression supérieure à la charge normale. Cela peut provoquer une blessure du ménisque médial du genou.",
                "2. Arthrite: Les cas graves (jambes en forme de O) peuvent éventuellement se développer en arthrose du genou et dégénérescence articulaire dans l'espace articulaire latéral. Dans les cas graves, une chirurgie de remplacement articulaire artificielle peut être nécessaire.",
            ],
        }
    },
    {
        name: "jambes en forme de X",
        key: "xleg",
        definition: {
            name: "Définition",
            list: "Quand une personne est debout dans une posture normale et que les jambes sont jointes, les genoux internes peuvent être proches l'un de l'autre, mais la partie interne des chevilles ne peut pas être proche et il peut même y avoir un grand espace. La forme entre les jambes est comme la lettre \"X\". Ce type de forme des jambes est lié aux habitudes posturales quotidiennes et au déséquilibre musculaire.",
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1. Mauvaises postures habituelles comme : inclinaison pelvienne antérieure, tendance à l'éversion du pied.",
                "2. Déséquilibre musculaire, comme : les muscles de rotation interne de la hanche trop serrés.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Blessure du ménisque latéral: Les jambes en forme de X entra?nent des changements dans la ligne de force des membres inférieurs. L'espace latéral du genou subit une pression supérieure à la charge normale. Cela peut provoquer une blessure du ménisque latéral du genou.",
                "2. Arthrite: Les cas graves (jambes en forme de X) peuvent éventuellement se développer en arthrose du genou et dégénérescence articulaire dans l'espace articulaire latéral. Dans les cas graves, une chirurgie de remplacement articulaire artificielle peut être nécessaire.",
            ],
        }
    },
    {
        name: "hyperextension du genou",
        key: "kneehyperextension",
        definition: {
            name: "Définition",
            list: ["Hyperextension du genou, également appelée ? arc inversé du genou ?. De c?té du corps humain, on peut voir que la jambe est courbée vers l'arrière, le genou est creux et le mollet est excessivement étendu vers l'avant par rapport à la cuisse. Ce type de posture est courant chez les danseuses de ballet et les personnes ayant une faiblesse musculaire des cuisses."],
        },
        triggerreason: {
            name: "Les causes",
            list: [
                "1. Mauvaise posture d'application de force : En position debout, le poids principal tombe sur la plante du pied avant.",
                "2. Tension de la fascia plantaire: Peut être causée par le port prolongé de talons hauts.",
                "3. Faiblesse musculaire autour du genou. Insuffisance de force musculaire à l'avant et à l'arrière de la cuisse.",
            ]
        },
        danger: {
            name: "Risques",
            list: [
                "1. Déformation du genou: Une hyperextension du genou à long terme peut entra?ner une augmentation significative de l'incidence de la dégénérescence articulaire et causer un usure excessive du genou, entra?nant une déformation articulaire.",
                "2. Dommage à l'équilibre général: Il existe une grande connexion positionnelle et fonctionnelle entre les trois articulations de la hanche, du genou et de la cheville. Un changement de la position du genou affectera la position de la cheville en dessous et la position de la hanche et du bassin au-dessus, nuisant progressivement à l'équilibre général du corps. à long terme, cela peut causer différents types de douleur.",
            ],
        }
    },
]